module.exports = __webpack_public_path__ + "img/5.55ba7566.jpg";